import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Pin } from 'lucide-react';
import { Button } from '../ui/button';

interface PinButtonProps {
    isPinned: boolean;
    onToggle: () => void;
    disabled?: boolean;
}

export const PinButton = ({ isPinned, onToggle, disabled }: PinButtonProps) => {
    const { t } = useTranslation();
    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
    };

    return (
        <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={handleClick}
            disabled={disabled}
            aria-label={
                isPinned ? t('folders.pin.unpin') : t('folders.pin.pin')
            }
            aria-pressed={isPinned}
            className={`h-6 w-6 [&_svg]:size-3.5 ${
                isPinned ? 'text-blue' : 'text-foreground'
            }`}
        >
            <Pin fill={isPinned ? 'currentColor' : 'none'} aria-hidden="true" />
        </Button>
    );
};
